export const SpinningProfiles = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      width="300"
      height="220"
      viewBox="0 0 300 220"
      className="text-primary mx-auto h-60 w-full"
    >
      <defs>
        <filter id="spinning-profiles-card-shadow" x="-50%" y="-50%" width="200%" height="200%" colorInterpolationFilters="sRGB">
          <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#000000" floodOpacity="0.06" />
          <feDropShadow dx="0" dy="6" stdDeviation="8" floodColor="#000000" floodOpacity="0.10" />
        </filter>
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_3_G"
          fill="freeze"
          keyTimes="0;0.732;0.932;1"
          path="M165.75 -87 C165.75,-87 165.75,-87 165.75,-87 C165.75,-51.58 165.75,90.08 165.75,125.5 C165.75,125.5 165.75,125.5 165.75,125.5 "
          keyPoints="0;0;1;1"
          keySplines="0.09 0.136 0 0.996;0.09 0.136 0 0.996;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_3_G"
          fill="freeze"
          attributeName="transform"
          from="-127.5 -88"
          to="-127.5 -88"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-127.5 -88;-127.5 -88"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_3_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="1"
          keyTimes="0;0.732;0.7320004;1"
          values="0;0;1;1"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_2_G"
          fill="freeze"
          keyTimes="0;0.416;0.616;0.716;0.916;1"
          path="M165.75 -87 C165.75,-87 165.75,-87 165.75,-87 C165.75,-51.58 165.75,90.08 165.75,125.5 C165.75,125.5 165.75,125.5 165.75,125.5 C165.75,156.58 165.75,280.92 165.75,312 C165.75,312 165.75,312 165.75,312 "
          keyPoints="0;0;0.53;0.53;1;1"
          keySplines="0.09 0.136 0 0.996;0.09 0.136 0 0.996;0.333 0.333 0 0;0.333 0 0 0.962;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_2_G"
          fill="freeze"
          attributeName="transform"
          from="-127.5 -88"
          to="-127.5 -88"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-127.5 -88;-127.5 -88"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_2_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.416;0.4160004;0.916;0.916;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_1_G"
          fill="freeze"
          keyTimes="0;0.1;0.3;0.4;0.6;1"
          path="M165.75 -87 C165.75,-87 165.75,-87 165.75,-87 C165.75,-51.58 165.75,90.08 165.75,125.5 C165.75,125.5 165.75,125.5 165.75,125.5 C165.75,156.58 165.75,280.92 165.75,312 C165.75,312 165.75,312 165.75,312 "
          keyPoints="0;0;0.53;0.53;1;1"
          keySplines="0.09 0.136 0 0.996;0.09 0.136 0 0.996;0.333 0.333 0 0;0.333 0 0 0.962;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_1_G"
          fill="freeze"
          attributeName="transform"
          from="-127.5 -88"
          to="-127.5 -88"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-127.5 -88;-127.5 -88"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_1_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.1;0.1000004;0.6;0.6;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_0_G"
          fill="freeze"
          keyTimes="0;0.084;0.284;1"
          path="M165.75 125.5 C165.75,125.5 165.75,125.5 165.75,125.5 C165.75,156.58 165.75,280.92 165.75,312 C165.75,312 165.75,312 165.75,312 "
          keyPoints="0;0;1;1"
          keySplines="0.333 0.333 0 0;0.333 0 0 0.962;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="-127.5 -88"
          to="-127.5 -88"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-127.5 -88;-127.5 -88"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_1_G_L_0_G_M"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.284;0.284;1"
          values="1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_0_G_D_2_P_0"
          fill="freeze"
          attributeName="fill-opacity"
          from="0.24"
          to="0.24"
          keyTimes="0;0.1;0.3;0.7;0.8;1"
          values="0.24;0.24;0;0;0.24;0.24"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_0_G_D_7_P_0"
          fill="freeze"
          attributeName="fill-opacity"
          from="0"
          to="0"
          keyTimes="0;0.1;0.2;0.8;0.9;1"
          values="0;0;0.24;0.24;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_0_G_D_8_P_0"
          fill="freeze"
          attributeName="fill-opacity"
          from="0"
          to="0"
          keyTimes="0;0.1;0.2;0.7;0.9;1"
          values="0;0;1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_0_G_D_9_P_0"
          fill="freeze"
          attributeName="fill-opacity"
          from="0"
          to="0"
          keyTimes="0;0.1;0.2;0.7;0.9;1"
          values="0;0;1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_0_G"
          fill="freeze"
          keyTimes="0;0.1;0.3;0.4;0.6;0.7;0.9;0.988;1"
          path="M59.69 161.67 C59.69,161.67 59.69,161.67 59.69,161.67 C90.07,161.81 242.02,162.5 242.02,162.5 C242.02,162.5 242.02,162.5 242.02,162.5 C242.02,162.5 242.02,78.25 242.02,78.25 C242.02,78.25 242.02,78.25 242.02,78.25 C242.02,78.25 90.07,147.77 59.69,161.67 C59.69,161.67 59.69,161.67 59.69,161.67 C59.69,161.67 59.69,161.67 59.69,161.67 "
          keyPoints="0;0;0.39;0.39;0.57;0.57;1;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="90"
          to="90"
          type="rotate"
          additive="sum"
          keyTimes="0;0.1;0.3;0.7;0.9;1"
          values="90;90;0;0;90;90"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="0.7000000000000001 0.7000000000000001"
          to="0.7000000000000001 0.7000000000000001"
          type="scale"
          additive="sum"
          keyTimes="0;1"
          values="0.7000000000000001 0.7000000000000001;0.7000000000000001 0.7000000000000001"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#spinning-profiles-_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="-49 -49"
          to="-49 -49"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-49 -49;-49 -49"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate attributeType="XML" attributeName="opacity" dur="10s" from="0" to="1" xlinkHref="#spinning-profiles-time_group" />
      </defs>
      <g id="spinning-profiles-_R_G">
        <g id="spinning-profiles-_R_G_L_1_G">
          <g id="spinning-profiles-_R_G_L_1_G_L_3_G_M" filter="url(#spinning-profiles-card-shadow)">
            <g id="spinning-profiles-_R_G_L_1_G_L_3_G">
              <path
                id="spinning-profiles-_R_G_L_1_G_L_3_G_D_0_P_0"
                fill="#ffffff"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M16.25 0.25 C16.25,0.25 207.25,0.25 207.25,0.25 C216.09,0.25 223.25,7.41 223.25,16.25 C223.25,16.25 223.25,128.25 223.25,128.25 C223.25,137.09 216.09,144.25 207.25,144.25 C207.25,144.25 16.25,144.25 16.25,144.25 C7.41,144.25 0.25,137.09 0.25,128.25 C0.25,128.25 0.25,16.25 0.25,16.25 C0.25,7.41 7.41,0.25 16.25,0.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_3_G_D_1_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M111.75 74.25 C125.01,74.25 135.75,63.51 135.75,50.25 C135.75,36.99 125.01,26.25 111.75,26.25 C98.5,26.25 87.75,36.99 87.75,50.25 C87.75,63.51 98.5,74.25 111.75,74.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_3_G_D_2_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M101.89 40.25 C101.89,45.83 106.42,54.22 111.99,54.22 C117.57,54.22 122.1,45.83 122.1,40.25 C122.1,34.67 117.57,30.15 112,30.15 C106.42,30.15 101.9,34.67 101.9,40.25 C101.9,40.25 101.89,40.25 101.89,40.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_3_G_D_3_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M123.58 61.32 C124.34,61.32 124.95,60.71 124.95,59.96 C124.95,59.2 124.34,58.59 123.58,58.59 C122.83,58.59 122.22,59.2 122.22,59.96 C122.22,60.71 122.83,61.32 123.58,61.32z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_3_G_D_4_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M123.57 53.82 C123.96,54.72 124.19,55.82 124.24,57.09 C125.55,57.39 126.53,58.56 126.53,59.96 C126.53,61.59 125.21,62.92 123.58,62.92 C121.95,62.92 120.62,61.59 120.62,59.96 C120.62,58.58 121.58,57.42 122.87,57.1 C122.82,55.84 122.51,53.92 121.28,52.97 C120.65,52.8 120,52.69 119.34,52.63 C119.29,54.84 111.98,60.29 111.98,60.29 C111.98,60.29 104.68,54.84 104.63,52.63 C103.89,52.69 103.18,52.83 102.48,53.02 C101.58,53.74 101.12,55.06 101.09,57 C101.35,57.15 101.57,57.39 101.7,57.67 C102.67,58.13 103.53,59.09 104.18,60.47 C104.29,60.7 104.31,60.96 104.23,61.2 C104.63,62.21 104.85,63.32 104.85,64.25 C104.85,65.55 104.85,66.78 103.43,67.1 C103.27,67.23 103.09,67.3 102.88,67.3 C102.88,67.3 101.93,67.3 101.93,67.3 C101.45,67.3 101.06,66.91 101.06,66.44 C101.06,66.44 101.06,66.4 101.06,66.4 C101.08,65.94 101.47,65.57 101.93,65.57 C101.93,65.57 102.88,65.57 102.88,65.57 C102.98,65.57 103.07,65.59 103.16,65.62 C103.22,65.61 103.24,65.59 103.24,65.59 C103.34,65.41 103.34,64.63 103.34,64.25 C103.34,63.5 103.16,62.59 102.82,61.74 C102.66,61.64 102.51,61.49 102.43,61.31 C101.85,60.11 101.07,59.33 100.44,59.33 C99.8,59.33 98.97,60.17 98.39,61.42 C98.3,61.63 98.14,61.79 97.93,61.89 C97.64,62.7 97.47,63.54 97.47,64.25 C97.47,64.57 97.47,65.4 97.59,65.6 C97.59,65.6 97.62,65.61 97.69,65.63 C97.79,65.59 97.9,65.58 98,65.58 C98,65.58 98.95,65.58 98.95,65.58 C99.4,65.58 99.77,65.91 99.81,66.35 C99.81,66.35 99.81,66.41 99.81,66.41 C99.81,66.92 99.43,67.3 98.95,67.3 C98.95,67.3 98,67.3 98,67.3 C97.81,67.3 97.63,67.24 97.48,67.12 C96.94,67.02 96.56,66.78 96.32,66.39 C96.02,65.92 95.97,65.3 95.97,64.25 C95.97,63.33 96.19,62.27 96.57,61.26 C96.52,61.04 96.53,60.81 96.63,60.61 C97.03,59.73 97.54,58.98 98.11,58.44 C98.42,58.14 98.76,57.9 99.1,57.72 C99.24,57.42 99.46,57.17 99.74,57.01 C99.75,55.8 99.94,54.75 100.28,53.89 C96.59,55.76 93.99,61.15 93.39,65.7 C97.79,70.93 104.38,74.25 111.75,74.25 C119.49,74.25 126.36,70.59 130.75,64.9 C130.23,60.45 127.22,55.62 123.58,53.82 C123.58,53.82 123.57,53.82 123.57,53.82z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_3_G_D_5_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M79.75 86.25 C79.75,84.04 81.54,82.25 83.75,82.25 C83.75,82.25 139.75,82.25 139.75,82.25 C141.96,82.25 143.75,84.04 143.75,86.25 C143.75,86.25 143.75,90.25 143.75,90.25 C143.75,92.46 141.96,94.25 139.75,94.25 C139.75,94.25 83.75,94.25 83.75,94.25 C81.54,94.25 79.75,92.46 79.75,90.25 C79.75,90.25 79.75,86.25 79.75,86.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_3_G_D_6_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M91.75 112.25 C91.75,108.94 94.44,106.25 97.75,106.25 C97.75,106.25 125.75,106.25 125.75,106.25 C129.06,106.25 131.75,108.94 131.75,112.25 C131.75,115.56 129.06,118.25 125.75,118.25 C125.75,118.25 97.75,118.25 97.75,118.25 C94.44,118.25 91.75,115.56 91.75,112.25z "
              />
            </g>
          </g>
          <g id="spinning-profiles-_R_G_L_1_G_L_2_G_M" filter="url(#spinning-profiles-card-shadow)">
            <g id="spinning-profiles-_R_G_L_1_G_L_2_G">
              <path
                id="spinning-profiles-_R_G_L_1_G_L_2_G_D_0_P_0"
                fill="#ffffff"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M16.25 0.25 C16.25,0.25 207.25,0.25 207.25,0.25 C216.09,0.25 223.25,7.41 223.25,16.25 C223.25,16.25 223.25,128.25 223.25,128.25 C223.25,137.09 216.09,144.25 207.25,144.25 C207.25,144.25 16.25,144.25 16.25,144.25 C7.41,144.25 0.25,137.09 0.25,128.25 C0.25,128.25 0.25,16.25 0.25,16.25 C0.25,7.41 7.41,0.25 16.25,0.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_2_G_D_1_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M111.75 74.25 C125.01,74.25 135.75,63.51 135.75,50.25 C135.75,36.99 125.01,26.25 111.75,26.25 C98.5,26.25 87.75,36.99 87.75,50.25 C87.75,63.51 98.5,74.25 111.75,74.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_2_G_D_2_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M101.89 40.25 C101.89,45.83 106.42,54.22 111.99,54.22 C117.57,54.22 122.1,45.83 122.1,40.25 C122.1,34.67 117.57,30.15 112,30.15 C106.42,30.15 101.9,34.67 101.9,40.25 C101.9,40.25 101.89,40.25 101.89,40.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_2_G_D_3_P_0"
                fill="currentColor"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M123.58 61.32 C124.34,61.32 124.95,60.71 124.95,59.96 C124.95,59.2 124.34,58.59 123.58,58.59 C122.83,58.59 122.22,59.2 122.22,59.96 C122.22,60.71 122.83,61.32 123.58,61.32z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_2_G_D_4_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M123.57 53.82 C123.96,54.72 124.19,55.82 124.24,57.09 C125.55,57.39 126.53,58.56 126.53,59.96 C126.53,61.59 125.21,62.92 123.58,62.92 C121.95,62.92 120.62,61.59 120.62,59.96 C120.62,58.58 121.58,57.42 122.87,57.1 C122.82,55.84 122.51,53.92 121.28,52.97 C120.65,52.8 120,52.69 119.34,52.63 C119.29,54.84 111.98,60.29 111.98,60.29 C111.98,60.29 104.68,54.84 104.63,52.63 C103.89,52.69 103.18,52.83 102.48,53.02 C101.58,53.74 101.12,55.06 101.09,57 C101.35,57.15 101.57,57.39 101.7,57.67 C102.67,58.13 103.53,59.09 104.18,60.47 C104.29,60.7 104.31,60.96 104.23,61.2 C104.63,62.21 104.85,63.32 104.85,64.25 C104.85,65.55 104.85,66.78 103.43,67.1 C103.27,67.23 103.09,67.3 102.88,67.3 C102.88,67.3 101.93,67.3 101.93,67.3 C101.45,67.3 101.06,66.91 101.06,66.44 C101.06,66.44 101.06,66.4 101.06,66.4 C101.08,65.94 101.47,65.57 101.93,65.57 C101.93,65.57 102.88,65.57 102.88,65.57 C102.98,65.57 103.07,65.59 103.16,65.62 C103.22,65.61 103.24,65.59 103.24,65.59 C103.34,65.41 103.34,64.63 103.34,64.25 C103.34,63.5 103.16,62.59 102.82,61.74 C102.66,61.64 102.51,61.49 102.43,61.31 C101.85,60.11 101.07,59.33 100.44,59.33 C99.8,59.33 98.97,60.17 98.39,61.42 C98.3,61.63 98.14,61.79 97.93,61.89 C97.64,62.7 97.47,63.54 97.47,64.25 C97.47,64.57 97.47,65.4 97.59,65.6 C97.59,65.6 97.62,65.61 97.69,65.63 C97.79,65.59 97.9,65.58 98,65.58 C98,65.58 98.95,65.58 98.95,65.58 C99.4,65.58 99.77,65.91 99.81,66.35 C99.81,66.35 99.81,66.41 99.81,66.41 C99.81,66.92 99.43,67.3 98.95,67.3 C98.95,67.3 98,67.3 98,67.3 C97.81,67.3 97.63,67.24 97.48,67.12 C96.94,67.02 96.56,66.78 96.32,66.39 C96.02,65.92 95.97,65.3 95.97,64.25 C95.97,63.33 96.19,62.27 96.57,61.26 C96.52,61.04 96.53,60.81 96.63,60.61 C97.03,59.73 97.54,58.98 98.11,58.44 C98.42,58.14 98.76,57.9 99.1,57.72 C99.24,57.42 99.46,57.17 99.74,57.01 C99.75,55.8 99.94,54.75 100.28,53.89 C96.59,55.76 93.99,61.15 93.39,65.7 C97.79,70.93 104.38,74.25 111.75,74.25 C119.49,74.25 126.36,70.59 130.75,64.9 C130.23,60.45 127.22,55.62 123.58,53.82 C123.58,53.82 123.57,53.82 123.57,53.82z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_2_G_D_5_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M79.75 86.25 C79.75,84.04 81.54,82.25 83.75,82.25 C83.75,82.25 139.75,82.25 139.75,82.25 C141.96,82.25 143.75,84.04 143.75,86.25 C143.75,86.25 143.75,90.25 143.75,90.25 C143.75,92.46 141.96,94.25 139.75,94.25 C139.75,94.25 83.75,94.25 83.75,94.25 C81.54,94.25 79.75,92.46 79.75,90.25 C79.75,90.25 79.75,86.25 79.75,86.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_2_G_D_6_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M91.75 112.25 C91.75,108.94 94.44,106.25 97.75,106.25 C97.75,106.25 125.75,106.25 125.75,106.25 C129.06,106.25 131.75,108.94 131.75,112.25 C131.75,115.56 129.06,118.25 125.75,118.25 C125.75,118.25 97.75,118.25 97.75,118.25 C94.44,118.25 91.75,115.56 91.75,112.25z "
              />
            </g>
          </g>
          <g id="spinning-profiles-_R_G_L_1_G_L_1_G_M" filter="url(#spinning-profiles-card-shadow)">
            <g id="spinning-profiles-_R_G_L_1_G_L_1_G">
              <path
                id="spinning-profiles-_R_G_L_1_G_L_1_G_D_0_P_0"
                fill="#ffffff"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M16.25 0.25 C16.25,0.25 207.25,0.25 207.25,0.25 C216.09,0.25 223.25,7.41 223.25,16.25 C223.25,16.25 223.25,128.25 223.25,128.25 C223.25,137.09 216.09,144.25 207.25,144.25 C207.25,144.25 16.25,144.25 16.25,144.25 C7.41,144.25 0.25,137.09 0.25,128.25 C0.25,128.25 0.25,16.25 0.25,16.25 C0.25,7.41 7.41,0.25 16.25,0.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_1_G_D_1_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M111.75 74.25 C125.01,74.25 135.75,63.51 135.75,50.25 C135.75,36.99 125.01,26.25 111.75,26.25 C98.5,26.25 87.75,36.99 87.75,50.25 C87.75,63.51 98.5,74.25 111.75,74.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_1_G_D_2_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M101.89 40.25 C101.89,45.83 106.42,54.22 111.99,54.22 C117.57,54.22 122.1,45.83 122.1,40.25 C122.1,34.67 117.57,30.15 112,30.15 C106.42,30.15 101.9,34.67 101.9,40.25 C101.9,40.25 101.89,40.25 101.89,40.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_1_G_D_3_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M123.58 61.32 C124.34,61.32 124.95,60.71 124.95,59.96 C124.95,59.2 124.34,58.59 123.58,58.59 C122.83,58.59 122.22,59.2 122.22,59.96 C122.22,60.71 122.83,61.32 123.58,61.32z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_1_G_D_4_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M123.57 53.82 C123.96,54.72 124.19,55.82 124.24,57.09 C125.55,57.39 126.53,58.56 126.53,59.96 C126.53,61.59 125.21,62.92 123.58,62.92 C121.95,62.92 120.62,61.59 120.62,59.96 C120.62,58.58 121.58,57.42 122.87,57.1 C122.82,55.84 122.51,53.92 121.28,52.97 C120.65,52.8 120,52.69 119.34,52.63 C119.29,54.84 111.98,60.29 111.98,60.29 C111.98,60.29 104.68,54.84 104.63,52.63 C103.89,52.69 103.18,52.83 102.48,53.02 C101.58,53.74 101.12,55.06 101.09,57 C101.35,57.15 101.57,57.39 101.7,57.67 C102.67,58.13 103.53,59.09 104.18,60.47 C104.29,60.7 104.31,60.96 104.23,61.2 C104.63,62.21 104.85,63.32 104.85,64.25 C104.85,65.55 104.85,66.78 103.43,67.1 C103.27,67.23 103.09,67.3 102.88,67.3 C102.88,67.3 101.93,67.3 101.93,67.3 C101.45,67.3 101.06,66.91 101.06,66.44 C101.06,66.44 101.06,66.4 101.06,66.4 C101.08,65.94 101.47,65.57 101.93,65.57 C101.93,65.57 102.88,65.57 102.88,65.57 C102.98,65.57 103.07,65.59 103.16,65.62 C103.22,65.61 103.24,65.59 103.24,65.59 C103.34,65.41 103.34,64.63 103.34,64.25 C103.34,63.5 103.16,62.59 102.82,61.74 C102.66,61.64 102.51,61.49 102.43,61.31 C101.85,60.11 101.07,59.33 100.44,59.33 C99.8,59.33 98.97,60.17 98.39,61.42 C98.3,61.63 98.14,61.79 97.93,61.89 C97.64,62.7 97.47,63.54 97.47,64.25 C97.47,64.57 97.47,65.4 97.59,65.6 C97.59,65.6 97.62,65.61 97.69,65.63 C97.79,65.59 97.9,65.58 98,65.58 C98,65.58 98.95,65.58 98.95,65.58 C99.4,65.58 99.77,65.91 99.81,66.35 C99.81,66.35 99.81,66.41 99.81,66.41 C99.81,66.92 99.43,67.3 98.95,67.3 C98.95,67.3 98,67.3 98,67.3 C97.81,67.3 97.63,67.24 97.48,67.12 C96.94,67.02 96.56,66.78 96.32,66.39 C96.02,65.92 95.97,65.3 95.97,64.25 C95.97,63.33 96.19,62.27 96.57,61.26 C96.52,61.04 96.53,60.81 96.63,60.61 C97.03,59.73 97.54,58.98 98.11,58.44 C98.42,58.14 98.76,57.9 99.1,57.72 C99.24,57.42 99.46,57.17 99.74,57.01 C99.75,55.8 99.94,54.75 100.28,53.89 C96.59,55.76 93.99,61.15 93.39,65.7 C97.79,70.93 104.38,74.25 111.75,74.25 C119.49,74.25 126.36,70.59 130.75,64.9 C130.23,60.45 127.22,55.62 123.58,53.82 C123.58,53.82 123.57,53.82 123.57,53.82z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_1_G_D_5_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M79.75 86.25 C79.75,84.04 81.54,82.25 83.75,82.25 C83.75,82.25 139.75,82.25 139.75,82.25 C141.96,82.25 143.75,84.04 143.75,86.25 C143.75,86.25 143.75,90.25 143.75,90.25 C143.75,92.46 141.96,94.25 139.75,94.25 C139.75,94.25 83.75,94.25 83.75,94.25 C81.54,94.25 79.75,92.46 79.75,90.25 C79.75,90.25 79.75,86.25 79.75,86.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_1_G_D_6_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M91.75 112.25 C91.75,108.94 94.44,106.25 97.75,106.25 C97.75,106.25 125.75,106.25 125.75,106.25 C129.06,106.25 131.75,108.94 131.75,112.25 C131.75,115.56 129.06,118.25 125.75,118.25 C125.75,118.25 97.75,118.25 97.75,118.25 C94.44,118.25 91.75,115.56 91.75,112.25z "
              />
            </g>
          </g>
          <g id="spinning-profiles-_R_G_L_1_G_L_0_G_M" filter="url(#spinning-profiles-card-shadow)">
            <g id="spinning-profiles-_R_G_L_1_G_L_0_G">
              <path
                id="spinning-profiles-_R_G_L_1_G_L_0_G_D_0_P_0"
                fill="#ffffff"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M16.25 0.25 C16.25,0.25 207.25,0.25 207.25,0.25 C216.09,0.25 223.25,7.41 223.25,16.25 C223.25,16.25 223.25,128.25 223.25,128.25 C223.25,137.09 216.09,144.25 207.25,144.25 C207.25,144.25 16.25,144.25 16.25,144.25 C7.41,144.25 0.25,137.09 0.25,128.25 C0.25,128.25 0.25,16.25 0.25,16.25 C0.25,7.41 7.41,0.25 16.25,0.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_0_G_D_1_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M111.75 74.25 C125.01,74.25 135.75,63.51 135.75,50.25 C135.75,36.99 125.01,26.25 111.75,26.25 C98.5,26.25 87.75,36.99 87.75,50.25 C87.75,63.51 98.5,74.25 111.75,74.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_0_G_D_2_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M101.89 40.25 C101.89,45.83 106.42,54.22 111.99,54.22 C117.57,54.22 122.1,45.83 122.1,40.25 C122.1,34.67 117.57,30.15 112,30.15 C106.42,30.15 101.9,34.67 101.9,40.25 C101.9,40.25 101.89,40.25 101.89,40.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_0_G_D_3_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M123.58 61.32 C124.34,61.32 124.95,60.71 124.95,59.96 C124.95,59.2 124.34,58.59 123.58,58.59 C122.83,58.59 122.22,59.2 122.22,59.96 C122.22,60.71 122.83,61.32 123.58,61.32z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_0_G_D_4_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M123.57 53.82 C123.96,54.72 124.19,55.82 124.24,57.09 C125.55,57.39 126.53,58.56 126.53,59.96 C126.53,61.59 125.21,62.92 123.58,62.92 C121.95,62.92 120.62,61.59 120.62,59.96 C120.62,58.58 121.58,57.42 122.87,57.1 C122.82,55.84 122.51,53.92 121.28,52.97 C120.65,52.8 120,52.69 119.34,52.63 C119.29,54.84 111.98,60.29 111.98,60.29 C111.98,60.29 104.68,54.84 104.63,52.63 C103.89,52.69 103.18,52.83 102.48,53.02 C101.58,53.74 101.12,55.06 101.09,57 C101.35,57.15 101.57,57.39 101.7,57.67 C102.67,58.13 103.53,59.09 104.18,60.47 C104.29,60.7 104.31,60.96 104.23,61.2 C104.63,62.21 104.85,63.32 104.85,64.25 C104.85,65.55 104.85,66.78 103.43,67.1 C103.27,67.23 103.09,67.3 102.88,67.3 C102.88,67.3 101.93,67.3 101.93,67.3 C101.45,67.3 101.06,66.91 101.06,66.44 C101.06,66.44 101.06,66.4 101.06,66.4 C101.08,65.94 101.47,65.57 101.93,65.57 C101.93,65.57 102.88,65.57 102.88,65.57 C102.98,65.57 103.07,65.59 103.16,65.62 C103.22,65.61 103.24,65.59 103.24,65.59 C103.34,65.41 103.34,64.63 103.34,64.25 C103.34,63.5 103.16,62.59 102.82,61.74 C102.66,61.64 102.51,61.49 102.43,61.31 C101.85,60.11 101.07,59.33 100.44,59.33 C99.8,59.33 98.97,60.17 98.39,61.42 C98.3,61.63 98.14,61.79 97.93,61.89 C97.64,62.7 97.47,63.54 97.47,64.25 C97.47,64.57 97.47,65.4 97.59,65.6 C97.59,65.6 97.62,65.61 97.69,65.63 C97.79,65.59 97.9,65.58 98,65.58 C98,65.58 98.95,65.58 98.95,65.58 C99.4,65.58 99.77,65.91 99.81,66.35 C99.81,66.35 99.81,66.41 99.81,66.41 C99.81,66.92 99.43,67.3 98.95,67.3 C98.95,67.3 98,67.3 98,67.3 C97.81,67.3 97.63,67.24 97.48,67.12 C96.94,67.02 96.56,66.78 96.32,66.39 C96.02,65.92 95.97,65.3 95.97,64.25 C95.97,63.33 96.19,62.27 96.57,61.26 C96.52,61.04 96.53,60.81 96.63,60.61 C97.03,59.73 97.54,58.98 98.11,58.44 C98.42,58.14 98.76,57.9 99.1,57.72 C99.24,57.42 99.46,57.17 99.74,57.01 C99.75,55.8 99.94,54.75 100.28,53.89 C96.59,55.76 93.99,61.15 93.39,65.7 C97.79,70.93 104.38,74.25 111.75,74.25 C119.49,74.25 126.36,70.59 130.75,64.9 C130.23,60.45 127.22,55.62 123.58,53.82 C123.58,53.82 123.57,53.82 123.57,53.82z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_0_G_D_5_P_0"
                fill="currentColor "
                fillOpacity="1"
                fillRule="nonzero"
                d=" M79.75 86.25 C79.75,84.04 81.54,82.25 83.75,82.25 C83.75,82.25 139.75,82.25 139.75,82.25 C141.96,82.25 143.75,84.04 143.75,86.25 C143.75,86.25 143.75,90.25 143.75,90.25 C143.75,92.46 141.96,94.25 139.75,94.25 C139.75,94.25 83.75,94.25 83.75,94.25 C81.54,94.25 79.75,92.46 79.75,90.25 C79.75,90.25 79.75,86.25 79.75,86.25z "
              />
              <path
                id="spinning-profiles-_R_G_L_1_G_L_0_G_D_6_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M91.75 112.25 C91.75,108.94 94.44,106.25 97.75,106.25 C97.75,106.25 125.75,106.25 125.75,106.25 C129.06,106.25 131.75,108.94 131.75,112.25 C131.75,115.56 129.06,118.25 125.75,118.25 C125.75,118.25 97.75,118.25 97.75,118.25 C94.44,118.25 91.75,115.56 91.75,112.25z "
              />
            </g>
          </g>
        </g>
        <g id="spinning-profiles-_R_G_L_0_G">
          <path
            id="spinning-profiles-_R_G_L_0_G_D_1_P_0"
            fill="#dbefff"
            fillOpacity="0.39"
            fillRule="nonzero"
            d=" M34 63 C17.98,63 5,50.02 5,34 C5,17.98 17.98,5 34,5 C50.02,5 63,17.98 63,34 C63,50.02 50.02,63 34,63z "
          />
          <path
            id="spinning-profiles-_R_G_L_0_G_D_2_P_0"
            fill="#585858"
            fillOpacity="0.24"
            fillRule="nonzero"
            d=" M36 3 C52.02,3 65,15.98 65,32 C65,40.52 61.33,48.18 55.48,53.48 C60.15,48.33 63,41.5 63,34 C63,17.98 50.02,5 34,5 C26.5,5 19.67,7.85 14.52,12.52 C19.82,6.67 27.48,3 36,3z  M14.52 12.52 C9.85,17.67 7,24.5 7,32 C7,48.02 19.98,61 36,61 C43.5,61 50.33,58.15 55.48,53.48 C50.18,59.33 42.52,63 34,63 C17.98,63 5,50.02 5,34 C5,25.48 8.67,17.82 14.52,12.52z "
          />
          <path
            id="spinning-profiles-_R_G_L_0_G_D_3_P_0"
            fill="#757575"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M58.44 51.38 C58.44,51.38 51.38,58.43 51.38,58.43 C51.38,58.43 71.67,78.73 71.67,78.73 C71.67,78.73 78.73,71.67 78.73,71.67 C78.73,71.67 58.44,51.38 58.44,51.38z "
          />
          <path
            id="spinning-profiles-_R_G_L_0_G_D_4_P_0"
            fill="#000000"
            fillOpacity="0.24"
            fillRule="nonzero"
            d=" M58.44 51.38 C58.44,51.38 51.38,58.43 51.38,58.43 C51.38,58.43 56,63.06 56,63.06 C56,63.06 57.5,63 60,60.5 C62.5,58 63.06,56 63.06,56 C63.06,56 58.44,51.38 58.44,51.38z "
          />
          <path
            id="spinning-profiles-_R_G_L_0_G_D_5_P_0"
            fill="currentColor "
            fillOpacity="1"
            fillRule="nonzero"
            d=" M95.52 95.51 C98.83,92.2 98.83,86.82 95.52,83.51 C95.52,83.51 72.81,60.8 72.81,60.8 C71.57,59.57 69.57,59.57 68.34,60.8 C68.34,60.8 60.81,68.33 60.81,68.33 C59.57,69.57 59.57,71.57 60.81,72.8 C60.81,72.8 83.51,95.51 83.51,95.51 C86.83,98.83 92.2,98.83 95.52,95.51z "
          />
          <path
            id="spinning-profiles-_R_G_L_0_G_D_6_P_0"
            fill="currentColor "
            fillOpacity="1"
            fillRule="nonzero"
            d=" M34.12 5.53 C49.9,5.53 62.7,18.33 62.7,34.11 C62.7,49.9 49.9,62.7 34.12,62.7 C18.33,62.7 5.54,49.9 5.54,34.11 C5.54,18.33 18.33,5.53 34.12,5.53z  M34.12 0 C15.28,0 0,15.28 0,34.12 C0,52.96 15.28,68.23 34.12,68.23 C52.96,68.23 68.23,52.96 68.23,34.12 C68.23,15.28 52.96,0 34.12,0z "
          />
          <path
            id="spinning-profiles-_R_G_L_0_G_D_7_P_0"
            fill="#000000"
            fillOpacity="0"
            fillRule="nonzero"
            d=" M60.81 68.34 C60.81,68.34 65.54,63.61 65.54,63.61 C64.3,64.84 64.3,66.84 65.54,68.08 C65.54,68.08 88.24,90.79 88.24,90.79 C90.72,93.26 94.34,93.89 97.4,92.67 C96.98,93.7 96.36,94.68 95.52,95.52 C92.2,98.83 86.83,98.83 83.51,95.52 C83.51,95.52 60.81,72.81 60.81,72.81 C59.57,71.57 59.57,69.57 60.81,68.34z "
          />
          <path
            id="spinning-profiles-_R_G_L_0_G_D_8_P_0"
            fill="#ffffff"
            fillOpacity="0"
            fillRule="nonzero"
            d=" M38.95 8.13 C42.67,9.18 45.26,11.53 44.74,13.39 C44.22,15.26 40.78,15.92 37.05,14.87 C33.33,13.83 30.74,11.47 31.26,9.61 C31.78,7.75 35.23,7.08 38.95,8.13z "
          />
          <path
            id="spinning-profiles-_R_G_L_0_G_D_9_P_0"
            fill="#ffffff"
            fillOpacity="0"
            fillRule="nonzero"
            d=" M49 14 C50.11,14 51,14.9 51,16 C51,17.11 50.11,18 49,18 C47.9,18 47,17.11 47,16 C47,14.9 47.9,14 49,14z "
          />
        </g>
      </g>
      <g id="spinning-profiles-time_group" />
    </svg>
  )
}
